document.addEventListener('DOMContentLoaded', () => {
  const discount_type_select = document.querySelector('.discount-type-select') as HTMLSelectElement;
  const offer_image_upload = document.querySelector('.coupon-offer-image-input') as HTMLSelectElement;
  const coupon_thumbnail_upload = document.querySelector('.coupon-thumbnail-input') as HTMLSelectElement;

  const update_discount_value = (selected_discount_type: string) => {
    const discount_type_list = [
      "PriceChange",
      "PriceDiscount",
      "PercentDiscount",
      "PointPresent",
      "FreePresent",
      "PointMultiplier"
    ]

    discount_type_list.forEach(type => {
      var discount_type_div = document.getElementById(type);

      if (type == selected_discount_type && discount_type_div) {
        // 選択された場合
        discount_type_div.style.display = 'block'
        var inputElement = discount_type_div.querySelector("input");
        if (inputElement) {
          inputElement.required = true;
          inputElement.disabled = false;
        }
      } else if (type != selected_discount_type && discount_type_div) {
        // 選択されていない場合
        discount_type_div.style.display = 'none'
        var inputElement = discount_type_div.querySelector("input");
        if (inputElement) {
          inputElement.required = false;
          inputElement.disabled = true;
        }
      }
    })
  }

  offer_image_upload.addEventListener('change', () => {
    var offer_image_div = document.getElementById('coupon-offer-image');
    if (offer_image_div) offer_image_div.style.display = 'none'
  });

  coupon_thumbnail_upload.addEventListener('change', () => {
    var coupon_thumbnail_div = document.getElementById('coupon-thumbnail');
    if (coupon_thumbnail_div) coupon_thumbnail_div.style.display = 'none'
  });

  discount_type_select.addEventListener('change', () => {
    const selected_discount_type = discount_type_select.value;
    update_discount_value(selected_discount_type)
  });

  const initialize_discount_select_value = () => {
    const selected_discount_type = discount_type_select.value;
    update_discount_value(selected_discount_type)
  }

  initialize_discount_select_value()
});
